var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"custom-progress-bar-back",style:(_vm.styleObject)},[_c('div',{staticClass:"custom-progress-bar",style:(_vm.withoutColor?'background-color: var(--goalBackgroundColor3)':'')})])
}
var staticRenderFns = []

export { render, staticRenderFns }